import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      export: {
        export_data: {
          header: 'HEADER',
          report_type: 'REPORT_TYPE',
          report_period: 'REPORT_PERIOD',
          report_name: 'REPORT_NAME',
          create_report_btn: 'CREATE',
        },
      },
    },
  }));
}
